import { useState ,useEffect} from "react";
import { Box, Button, FormControlLabel, Switch, TextField, Grid, FormControl } from "@mui/material";
import { LedgerQueryViewModel, Option } from "../../Types/ExportTypes";
import { CustomerAutoComplete, SupplierAutoComplete, CountryAutoComplete, LocationAutoComplete, ShopAutoComplete, SalespersonAutoComplete, ItemAutoComplete, ItemGroupAutoComplete, ProgramAutoComplete, CollectionAutoComplete } from "../AutoComplete/AutoCompletes";
import AsyncAutoComplete from "../AsyncAutoComplete";
import { useAuth, useSnackbar, useLoading, useNavigation } from "../../Context/Contexts";
import { useTranslation } from "react-i18next";
interface ReportHeaderProps {
    filter: LedgerQueryViewModel;
    onGenerate?: (filter: LedgerQueryViewModel) => void;
}

const LedgerReportHeader: React.FC<ReportHeaderProps> = ({ filter, onGenerate }) => {
    const [showAdvanced, setShowAdvanced] = useState(false);
    const [localFilter, setLocalFilter] = useState<LedgerQueryViewModel>(filter);

    const { authService } = useAuth();
    const { goBack, navigate } = useNavigation();
    const { showSnackbar } = useSnackbar();
    const { showLoading, hideLoading } = useLoading();
    const { t } = useTranslation();

    const handleFilterChange = (key: keyof LedgerQueryViewModel, value: string | null) => {
        setLocalFilter((prev) => ({ ...prev, [key]: value }));
    };

    const handleGenerate = () => {
        onGenerate?.(localFilter);
    };



    return (
        <Box sx={{ p: 2, borderBottom: 1, borderColor: "divider" }}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={3}>
                    <TextField
                        label={t("common.postingDate")}
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        value={localFilter.postingDate || ""}
                        onChange={(e) => handleFilterChange("postingDate", e.target.value || null)}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        label={t("common.documentNo")}
                        type="text"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        value={localFilter.documentNo || ""}
                        onChange={(e) => handleFilterChange("documentNo", e.target.value || null)}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControlLabel
                        control={<Switch checked={showAdvanced} onChange={() => setShowAdvanced(!showAdvanced)} />}
                        label={t("common.advancedFilter")}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button variant="contained" color="success" fullWidth onClick={handleGenerate}>
                        {t("common.fetch")}
                    </Button>
                </Grid>
            </Grid>

            {showAdvanced && (
                <Box sx={{ mt: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={3}>
                            <FormControl fullWidth margin="normal">
                                <CustomerAutoComplete
                                    onChange={(selected) => handleFilterChange("customerNo", selected?.value || "")}
                                    infoText={t("help.filterCustomer")}
                                />

                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <FormControl fullWidth margin="normal">
                                <SupplierAutoComplete
                                    onChange={(selected) => handleFilterChange("supplierNo", selected?.value || "")}
                                    infoText={t("help.filterSupplier")}
                                />

                            </FormControl>
                        </Grid>
              
                       
                        <Grid item xs={6} sm={3}>
                            <FormControl fullWidth margin="normal">
                                <LocationAutoComplete
                                    onChange={(selected) => handleFilterChange("locationCode", selected?.value || "")}
                                    infoText={t("help.filterLocation")}
                                />

                            </FormControl>
                        </Grid>
                

                        <Grid item xs={6} sm={3}>
                            <FormControl fullWidth margin="normal">
                                <ItemAutoComplete
                                    onChange={(selected) => handleFilterChange("itemNo", selected?.value || "")}
                                    infoText={t("help.filterItem")}
                                />

                            </FormControl>
                        </Grid>

                    
                       

                    </Grid>
                </Box>
            )}
        </Box>
    );
};

export default LedgerReportHeader;
